var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 54,
    viewBox: "0 0 30 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.751 17.1562H16.9324L20.9261 3.84668C21.3011 2.28809 20.223 0.75 18.7511 0.75H5.2513C4.12631 0.75 3.17007 1.6626 3.02007 2.88281L0.0201077 27.4922C-0.158015 28.9687 0.891973 30.2812 2.25133 30.2812H13.3793L9.0575 50.2251C8.72001 51.7837 9.8075 53.25 11.2419 53.25C12.02 53.25 12.7793 52.7988 13.1918 52.0195L29.6916 20.8477C30.5635 19.2173 29.4854 17.1562 27.751 17.1562ZM13.1543 45.5493L16.2949 31.0298L17.1668 26.9897H3.10445L5.90754 4.03125H17.7105L14.0824 16.1309L12.7887 20.4375H26.4479L13.1543 45.5493Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZap);
export default __webpack_public_path__ + "static/media/zap.4ac99b3d1ee833504cb4ab1d4bfb584a.svg";
export { ForwardRef as ReactComponent };